<template>
  <div
    class="notification-banner is-fullwidth"
    :class="{
      'has-background-warning-light': isWarning,
      'has-text-warning-dark': isWarning,
      'has-background-info-light': isInfo,
      'has-text-info-dark': isInfo,
      'has-background-danger-light': isDanger,
      'has-text-danger-dark': isDanger
    }"
    v-if="show"
  >
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'BannerNotification',
  props: [
    'control',
    'isWarning',
    'isInfo',
    'isDanger'
  ],
  watch: {
    control() {
      this.show = this.control;
    }
  },
  data() {
    return {
      show: this.control
    };
  }
};
</script>
<style lang="scss" scoped>
.notification-banner {
  padding: 0.5rem 1rem;

  strong {
    color: inherit;
  }
}
</style>
